/**
 * Detects if the user is on a touch device (e.g., mobile, tablet).
 * Uses the hover and pointer media queries to determine if the device
 * has a coarse pointer (touch) and no hover capability.
 *
 * This is a simple utility function, not a hook, because the media query
 * result is independent of React's component lifecycle.
 *
 * @returns true if the device is a touch device, false otherwise
 */
export const isTouchDevice = (): boolean => {
    return window.matchMedia("(hover: none) and (pointer: coarse)").matches;
};
